<script>
import ButtonSwitch from "@/components/molecules/button-switch";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import LazyImage from "@/components/atoms/lazy-image";
import Card from "@/components/molecules/card";
import Titre from "@/components/atoms/titre";
import Button from "@/components/atoms/button";
import AbonnementOverview from "@/components/organisms/mon-compte/abonnement-overview/mobile";
import {
  pageMonCompteAbonnementsProps,
  usePageMonCompteAbonnements
} from "./mixin";

import paperSheetSad from "@/assets/images/paper-sheet-sad.svg";

export default {
  name: "MesAbonnementsMobile",
  components: {
    ButtonSwitch,
    List,
    ListItem,
    LazyImage,
    Card,
    Titre,
    Button,
    AbonnementOverview
  },
  props: {
    ...pageMonCompteAbonnementsProps()
  },
  setup(props) {
    const { abonnementsEnCours, abonnementsTermine } =
      usePageMonCompteAbonnements(props);
    return {
      abonnementsEnCours,
      abonnementsTermine,
      paperSheetSad
    };
  },
  data() {
    return {
      filtreAbonnementState: 0
    };
  },
  methods: {
    changeCommandeType(state) {
      this.filtreAbonnementState = state;
    },
    getAbonnementsList() {
      return this.filtreAbonnementState
        ? this.abonnementsTermine
        : this.abonnementsEnCours;
    }
  }
};
</script>

<template>
  <div>
    <Titre
      tag="h1"
      variant="primary"
      size="md"
      class="u-mb-sm u-mt-sm u-pl-sm u-pr-sm"
    >
      Mes abonnements
    </Titre>
    <div>
      <div
        v-if="abonnementsTermine.length !== 0"
        class="u-text-center u-mb-md"
      >
        <ButtonSwitch
          :active-index="0"
          label-left="En cours"
          label-right="Terminés"
          @change="changeCommandeType"
        />
      </div>
      <div
        v-if="filtreAbonnementState === 0 && abonnementsEnCours.length === 0"
        class="u-flex u-flex-column u-flex-align-center"
      >
        <Card class="u-px-sm u-py-lg u-border-y-border u-mb-sm">
          <div class="u-flex u-flex-column u-flex-align-center">
            <LazyImage
              :src="paperSheetSad"
              width="90"
              height="73"
              class="u-inline-block u-mb-xs"
            />
            <template v-if="abonnementsTermine.length !== 0">
              <Titre
                tag="h2"
                size="sm"
                class="u-text-center u-mb-xs"
              >
                Vous n'avez pas d'abonnement en cours
              </Titre>
              <p class="u-text-center u-font-15 u-mb-md">
                Réabonnez-vous pour faire des économies et vous simplifier la vie !
              </p>
              <Button
                size="md"
                variant="secondary"
                radius="full"
                to="/abonnement-livraison"
              >
                Je m'abonne à nouveau
              </Button>
              <Button
                link
                class="u-mt-md"
                to="/legal/informations-juridiques/conditions-generales-de-vente-abonnement-livraison"
              >
                Voir les conditions de l'offre
              </Button>
            </template>
            <template v-else>
              <Titre
                tag="h2"
                size="sm"
                class="u-text-center u-mb-xs"
              >
                Vous n'avez pas d'abonnement en cours
              </Titre>
              <p class="u-text-center u-font-15 u-mb-md">
                Grâce à l'abonnement à la livraison, faites des économies et simplifiez-vous la vie !
              </p>
              <Button
                size="md"
                variant="secondary"
                radius="full"
                to="/abonnement-livraison"
              >
                Je découvre
              </Button>
              <div class="u-mt-md">
                <Button
                  link
                  to="/legal/informations-juridiques/conditions-generales-de-vente-abonnement-livraison"
                >
                  Voir les conditions de l'offre
                </Button>
              </div>
            </template>
          </div>
        </Card>
      </div>
      <div
        v-else
        class="u-px-sm"
      >
        <List class="u-mb-md">
          <ListItem
            v-for="(subscription, i) in getAbonnementsList()"
            :key="i"
            class="u-mb-sm"
          >
            <AbonnementOverview :abonnement="subscription" />
          </ListItem>
        </List>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
